import React from "react";

export default function JunkEstimator() {
  return (
    <div>
      {/* Top Section */}
      <section className="estimator-top-section">
        <div className="top-container">
          <div className="top-left centered">
            <h2 className="small-heading">Smart Tool</h2>
            <h1 className="main-heading">Junk Removal Estimator</h1>

            <p className="top-paragraph">
              Get an accurate estimate for your junk removal services using our
              smart estimator. Designed to help businesses and customers quickly
              understand pricing and scope before booking.
            </p>

            {/* Video */}
            <div className="video-wrapper">
              <video
                className="estimator-video"
                controls
                autoPlay
                muted
                loop
              >
                <source
                  src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/videos/Junk%20Removal%20%20Estimator.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Section */}
      <section className="estimator-info-section">
        <h2 className="big-heading">Why Use Our Estimator?</h2>
        <p className="info-paragraph">
          Our junk removal estimator simplifies your workflow by giving instant
          pricing insights. It helps you close more deals, save time, and deliver
          a better experience to your customers.
        </p>

        <div className="cards-container">
          <div className="info-card">
            <h3>Fast Estimates</h3>
            <p>
              Generate quick and accurate quotes without manual calculations or
              delays.
            </p>
          </div>

          <div className="info-card">
            <h3>Increase Conversions</h3>
            <p>
              Provide instant clarity to your leads and improve your closing
              rates significantly.
            </p>
          </div>

          <div className="info-card">
            <h3>Easy Integration</h3>
            <p>
              Seamlessly fits into your existing workflow and tools with minimal
              setup required.
            </p>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        /* Top Section */
        .estimator-top-section {
          background: #000;
          color: #fff;
          padding: 80px 20px;
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif;
        }

        .top-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .centered {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .small-heading {
          font-size: 28px;
          font-weight: 700;
          color: #7b19bc;
          margin: 0;
        }

        .main-heading {
          font-size: 52px;
          font-weight: 800;
          margin: 6px 0;
          line-height: 1.1;
        }

        .top-paragraph {
          font-size: 17px;
          margin: 10px 0 20px;
          max-width: 700px;
          line-height: 1.5;
        }

        /* Video */
        .video-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }

        .estimator-video {
          width: 80%;
          max-width: 900px;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.5);
        }

        /* Bottom Section */
        .estimator-info-section {
          background: #fff;
          padding: 80px 20px;
          text-align: center;
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif;
        }

        .big-heading {
          font-size: 46px;
          font-weight: 800;
          margin-bottom: 16px;
          color: #7b19bc;
        }

        .info-paragraph {
          font-size: 16px;
          margin-bottom: 40px;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }

        .cards-container {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .info-card {
          background: #fff;
          padding: 30px 20px;
          border-radius: 12px;
          min-width: 280px;
          max-width: 350px;
          text-align: left;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          transition: 0.3s;
        }

        .info-card:hover {
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }

        .info-card h3 {
          color: #7b19bc;
          margin-bottom: 10px;
        }

        @media (max-width: 768px) {
          .main-heading {
            font-size: 36px;
          }

          .estimator-video {
            width: 95%;
          }
        }
      `}</style>
    </div>
  );
}